module.exports = __webpack_public_path__ + "814d78e54c22f5e4e00a8e7b240a5f63.png";